import { IMenuItemStyles } from "@fluentui/react/lib/ContextualMenu";
import { ITheme, mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import {
  baseFabricFocusSelector,
  commonHighContrastHoverFocusStyles,
  commonHighContrastOutlineHoverFocus,
  commonHighContrastOutlineToggledOn,
  getStandardControlSemanticColorsWithTheme,
  IMenuItemClassNames,
  StandardControlSemanticColors,
} from "@1js/acui-common";
import { isThemingEnabled } from "@1js/acui-theme";

import {
  ControlInMenuStylesFunction,
  getClassNamesForMenuButton,
  getStylesFromControlInMenuFnOrObject,
} from "../AppBaseButton/AppBaseButtonInMenu.classNames";

const redlineClassNamesForFlyoutAnchorMenuButton = (
  appControlSemanticColors: StandardControlSemanticColors,
  disabled: boolean,
  expanded: boolean,
  checked: boolean
): Partial<IMenuItemClassNames> => {
  return mergeStyleSets({
    root: [
      {
        paddingRight: 0,
        selectors: {
          ":hover": [
            {
              backgroundColor: appControlSemanticColors.hoverBackgroundColor,
            },
            commonHighContrastHoverFocusStyles,
            commonHighContrastOutlineHoverFocus,
          ],
          ":active": [
            {
              backgroundColor: appControlSemanticColors.pressedBackgroundColor,
            },
          ],
        },
      },
      expanded && [
        commonHighContrastOutlineToggledOn,
        commonHighContrastHoverFocusStyles,
      ],
      checked && [
        {
          backgroundColor: appControlSemanticColors.toggledBackgroundColor,
          border: `1px solid ${appControlSemanticColors.selectedBorderColor}`,
        },
        commonHighContrastOutlineToggledOn,
        commonHighContrastHoverFocusStyles,
      ],
      disabled &&
        checked && {
          selectors: {
            [baseFabricFocusSelector]: {
              backgroundColor: appControlSemanticColors.toggledBackgroundColor,
            },
          },
        },
    ],
    subMenuIcon: [
      {
        display: "flex",
        width: 38,
        height: 16,
        justifyContent: "center",
        fill: isThemingEnabled()
          ? appControlSemanticColors.textColor
          : "#444444",
      },
      disabled && {
        opacity: 0.4,
      },
    ],
    label: {
      paddingRight: 12,
    },
  });
};

export const getClassNamesForFlyoutAnchorMenuButton = (
  customMenuItemStyles?: Partial<IMenuItemStyles> | ControlInMenuStylesFunction
) => {
  return memoizeFunction(
    (
      theme: ITheme,
      disabled: boolean,
      expanded: boolean,
      checked: boolean
    ): IMenuItemClassNames => {
      const appControlSemanticColors: StandardControlSemanticColors =
        getStandardControlSemanticColorsWithTheme(theme);
      return mergeStyleSets(
        getClassNamesForMenuButton()(theme, disabled, expanded),
        redlineClassNamesForFlyoutAnchorMenuButton(
          appControlSemanticColors,
          disabled,
          expanded,
          checked
        ),
        customMenuItemStyles
          ? getStylesFromControlInMenuFnOrObject(
              customMenuItemStyles,
              disabled,
              expanded,
              checked
            )
          : customMenuItemStyles
      );
    }
  );
};
